import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { grey, primaryText, white } from 'src/data/colors';
import { theme } from 'src/components/theme';

export interface StatusProps {
  percentage?: number;
  value?: number;
  showValue?: boolean;
  valueUnit?: string;
  color: string;
  installed?: boolean;
  onOfGrid?: boolean;
}

const useStyles = makeStyles<Theme, { filledColor: string; color: string }>(() =>
  createStyles({
    root: {
      width: '100%',
      height: 35,
      borderRadius: 8,
      overflow: 'hidden',
      border: '1px solid #e0e0e0',
      display: 'flex',
      position: 'relative',
    },
    filledSection: ({ filledColor }) => ({
      height: '100%',
      backgroundColor: filledColor,
      display: 'flex',
      alignItems: 'center',
    }),
    remainingSection: {
      height: '100%',
      width: '100%',
      backgroundColor: grey,
      display: 'flex',
      alignItems: 'center',
    },
    whiteSection: {
      backgroundColor: '#FFFFFF',
    },
    whiteText: {
      color: ({ color }) => (color === white ? primaryText : white),
      fontSize: 16,
      fontWeight: 500,
      padding: 8,
      whiteSpace: 'nowrap',
      position: 'absolute',
      left: 0,
      top: -3,
    },
    blackText: {
      color: '#000000',
      fontSize: 16,
      fontWeight: 500,
      padding: 8,
      position: 'absolute',
    },
    notInstalledText: {
      color: grey,
      fontSize: 16,
      fontWeight: 500,
      padding: 8,
      position: 'absolute',
      left: 0,
      top: -3,
      [theme.breakpoints.down('sm')]: {
        top: -2,
        fontSize: 14,
      },
    },
  })
);

const Status: React.FC<StatusProps> = ({
  percentage,
  value,
  valueUnit = 'W',
  color,
  installed,
  onOfGrid,
}) => {
  const classes = useStyles({ filledColor: color, color: color });

  if (!!percentage) {
    return (
      <div style={{ padding: 8 }}>
        <Box className={classes.root}>
          <Box className={classes.remainingSection}>
            <Box className={classes.filledSection} style={{ width: `${percentage}%` }}></Box>
          </Box>
          <Typography className={classes.whiteText}>{percentage?.toFixed(1)} %</Typography>
          {!!value && (
            <Typography
              className={classes.whiteText}
              style={{ right: '0px', top: '-3px', left: 'auto' }}
            >
              {value} {valueUnit}
            </Typography>
          )}
        </Box>
      </div>
    );
  }
  if (installed) {
    return (
      <div style={{ padding: 8 }}>
        <Box className={classes.root}>
          <Box className={classes.filledSection} style={{ width: `100%` }}></Box>
          <Typography className={classes.whiteText}>
            {value} {valueUnit}
          </Typography>
          {onOfGrid !== undefined && (
            <Typography
              className={classes.whiteText}
              style={{ right: '0px', top: '-3px', left: 'auto' }}
            >
              {onOfGrid ? 'On Grid' : 'Off Grid'}
            </Typography>
          )}
        </Box>
      </div>
    );
  }

  return (
    <div style={{ padding: 8 }}>
      <Box className={classes.root}>
        <Box className={classes.whiteSection} style={{ width: `100%` }}></Box>
        <Typography className={classes.notInstalledText}>{'Not detected'}</Typography>
      </Box>
    </div>
  );
};

export default Status;
